<template>
  <div id="hmczimun">
    <router-view />
    <modal
      name="pageLoader"
      :adaptive="true"
      height="auto"
      styles="background-color:initial;overflow:initial;box-shadow:initial;"
    >
      <PageLoader />
    </modal>
  </div>
</template>
<script>
import PageLoader from "./components/PageLoader";
import { mapActions, mapGetters, mapMutations } from "vuex";
import firebaseInitialize from "./firebase";
import AppUpdate from "./components/Popups/AppUpdate";
import { isOutdatedApplication } from "./utilities/globals";

export default {
  computed: {
    ...mapGetters(["MENU_ACTIVE", "activeUser", "activeDoctor", "docsTypes"])
  },
  data() {
    return {
      isKeyboard: false
    };
  },
  methods: {
    ...mapActions([
      "SET_CONNECTCTED_CALENDARS",
      "SET_DOCTOR",
      "SET_ALL_ROOMS",
      "SET_USER",
      "LOGOUT",
      "GET_DOCS_LIST"
    ]),
    ...mapMutations(["SET_DOCTOR_ROOMS"]),
    setBackgroundStyle() {
      const white_body = document.getElementsByClassName("white--body");
      const body = document.getElementsByTagName("body");
      if (
        white_body.length > 0 ||
        (this.$route.name &&
          (this.$route.name.includes("surg-edit") ||
            this.$route.name.includes("surg-info")))
      ) {
        body[0].classList.add("bg--white");
      } else {
        body[0].classList.remove("bg--white");
      }
    },
    keyboardListener() {
      const isMobile = window.innerWidth < 1200;
      if (isMobile) {
        window.visualViewport.addEventListener("resize", event => {
          if (this.isKeyboard) document.body.classList.remove("keyboard");
          else document.body.classList.add("keyboard");
          this.isKeyboard = !this.isKeyboard;
        });

        document.body.addEventListener(
          "blur",
          () => {
            document.body.classList.remove("keyboard");
          },
          true
        );
      }
    }
  },
  async created() {
    firebaseInitialize();

    this.setBackgroundStyle();

    this.keyboardListener();

    /** get all user info if logged in */
    const token = this.$cookies.get("hmc_token");
    if (!token) return;

    const resUserInfo = await this.$API.getUserInfo();
    await this.SET_USER(resUserInfo.message);

    const res = await this.$API.getConnectedCalendars(this.activeUser.user_id);
    if (res.status == "OK") {
      if (!res.message.length) {
        this.LOGOUT().then(() => {
          this.$API.logout().then(() => this.$router.push("/"));
        });
      } else {
        this.SET_CONNECTCTED_CALENDARS(res.message);
      }
      const activeUser = JSON.parse(localStorage.getItem("activeDoctor"));
      if (activeUser && activeUser.id) this.SET_DOCTOR(activeUser.id);
      else this.SET_DOCTOR(res.message[0].id);
      const id =
        activeUser && activeUser.id ? activeUser.id : res.message[0].id;
      this.$API
        .getRoomsByDoctor(id)
        .then(res => {
          this.SET_DOCTOR_ROOMS(res.data.data);
        })
        .catch(err => {
          this.SET_DOCTOR(res.message[0].id);
        });

      const docsTypes = Object.keys(this.docsTypes);
      if (docsTypes.some(type => this.$route.path.includes(type))) {
        this.GET_DOCS_LIST();
      }
    }

    const resRooms = await this.$API.getTypehead("rooms");
    this.SET_ALL_ROOMS(resRooms);
  },
  mounted() {
    /**
     * Sits on the root component so that the notice comes up on every entry
     * to the application, no matter which route the user lands on.
     *
     * Deferred by a tick because vue-js-modal injects the container its
     * dynamic modals render into onto the root instance, which is the very
     * component still mounting here.
     */
    // if (isOutdatedApplication()) {
    //   this.$nextTick(() => this.$modal.show(AppUpdate));
    // }
  },
  updated() {
    this.setBackgroundStyle();
  },
  watch: {
    $route(to, from) {
      if (to.fullPath != from.fullPath) this.setBackgroundStyle();
    }
  },
  components: { PageLoader }
};
</script>
<style>
.vm--modal {
  overflow: initial;
  box-sizing: border-box;
  background-color: initial;
  border-radius: 0px;
  box-shadow: initial;
}
.vm--modal {
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
}
.show_overflow {
  overflow: scroll !important;
}

/* For Indicator */

.state-indicator {
  position: absolute;
  top: -999em;
  left: -999em;

  z-index: 1;
}

@media all and (max-width: 1200px) {
  .state-indicator {
    z-index: 2;
  }
}

@media all and (max-width: 1024px) {
  .state-indicator {
    z-index: 3;
  }
}

@media all and (max-width: 768px) {
  .state-indicator {
    z-index: 4;
  }
}
</style>
